export default __webpack_public_path__ + "assets/overview-header-bg-d9f5e6c4fd046e9bbf6aa494b434e605.jpg";